export default __webpack_public_path__ + "static/media/ga.70dbf886.svg";